module.exports = "/lucky-balls/img/bonus_green/check_infoBar/check_001.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/check_infoBar/check_001.png
// module id = 924
// module chunks = 0